const brake = 'https://ik.imagekit.io/sbrqdqxneo/Tips/brake-cut.jpg?updatedAt=1759423911095';
const oil = 'https://ik.imagekit.io/sbrqdqxneo/Tips/oil-cut.jpg?updatedAt=1759423815462';
const battery = 'https://ik.imagekit.io/sbrqdqxneo/Tips/battery.jpg?updatedAt=1759423709039';
const tire = 'https://ik.imagekit.io/sbrqdqxneo/Tips/tire-cut.jpg?updatedAt=1759423900845';

export { brake, oil, tire, battery };
